import { STEP_NAMES } from '../cashFlow/constants';

export const SAVE_FORM_DATA = 'SAVE_FORM_DATA';
export const FORM_ERROR_DATA = 'ERROR_FORM_DATA';
export const SET_CURRENT_INDEX = 'SET_CURRENT_INDEX';
export const CREATE_ACCOUNT_DATA = 'CREATE_ACCOUNT_DATA';

export const initialGuidedRegState = {
    emailId: '',
    accountType: '',
    currentStepIndex: 0,
    formData: {
        [STEP_NAMES[0]]: {
            data: {
                firstName: '',
                lastName: '',
                dateOfBirth: '',
                mobileNumber: '',
                password: '',
            }
        },
        [STEP_NAMES[1]]: {
            data: {
                country: 'US',
                address: '',
                address2: '',
                city: '',
                state: '',
                zipCode: '',
                isAgree: false,
                isSmsOptin: false,
                isPrivacyPolicy: false,
                driversLicenseState: '',
                driversLicenseNumber: ''
            }
        }
    }
};

export const GuidedRegReducer = () => {
    return (state, action) => {
        console.log('**', state);
        switch (action.type) {
            case SAVE_FORM_DATA:
                return {
                    ...state,
                    formData: {
                        ...state.formData,
                        [action.payload.step]: {
                            ...state.formData[action.payload.step],
                            data: action.payload.data,
                            status: action.payload.status
                        }
                    }
                };

            case FORM_ERROR_DATA:
                return {
                    ...state,
                    formData: {
                        ...state.formData,
                        [action.payload.step]: {
                            ...state.formData[action.payload.step],
                            error: action.payload.error
                        }
                    }
                };

            case SET_CURRENT_INDEX:
                return {
                    ...state,
                    currentStepIndex: action.payload
                };

            case CREATE_ACCOUNT_DATA:
                return {
                    ...state,
                    emailId: action.payload.email,
                    accountType: action.payload.accountType
                };

            default:
                return state;
        }
    };
};
